import React, { useContext, useState, useEffect } from "react";
import { useObserver } from "mobx-react-lite";
import { Redirect, useParams, Link } from "react-router-dom";
import { DocumentArrowDownIcon } from "@heroicons/react/24/outline";
import Spinner from "components/Icons/Spinner";

import { AuthContext } from "stores/auth";
import { exportEndOfYear } from "api/core";
import { classNames } from "components/utils";

const EOYExport = () => {
  const authStore = useContext(AuthContext);
  let { uid } = useParams();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const selectedAccount = authStore.selectedAccount;
    setLoading(true);
    if (
      authStore?.user?.email.includes("@exploration.io") ||
      (selectedAccount && uid === selectedAccount.uid)
    ) {
      exportEndOfYear(uid, 2025)
        .then((res) => {
          var data = new Blob([res?.data], {
            type: "application / vnd. MS Excel",
          });
          var csvURL = window.URL.createObjectURL(data);
          var tempLink = document.createElement("a");
          tempLink.href = csvURL;
          tempLink.setAttribute("download", `End of Year Report.xlsx`);
          tempLink.click();

          setLoading(false);
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      setLoading(false);
    }
  }, [uid]);

  return useObserver(() => {
    if (loading) {
      return (
        <main className="grid min-h-full place-items-center bg-white px-6 py-24 sm:py-32 lg:px-8">
          <div className="text-center">
            <div className="flex gap-x-2 justify-center items-center w-full">
              <div className="mt-4">
                <Spinner />
              </div>
              <h1 className="mt-4 text-5xl font-semibold tracking-tight text-balance text-gray-600 sm:text-5xl">
                Exporting Report
              </h1>
            </div>
            <p className="mt-6 text-lg font-medium text-pretty text-gray-400 sm:text-xl/8">
              Please wait while we prepare your End of Year report for 2025...
            </p>
            <div className="mt-10 flex items-center justify-center gap-x-6">
              <Link
                to="/"
                className="rounded-md bg-indigo-500 px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs hover:bg-indigo-400 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-500"
              >
                Go back home
              </Link>
            </div>
          </div>
        </main>
      );
    } else {
      return <Redirect to="/" />;
      // return <></>;
    }
  });
};

export default EOYExport;
